import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { AsyncPipe, JsonPipe, NgClass, NgForOf, NgIf, NgOptimizedImage } from "@angular/common";
import { EventType, NavigationEnd, Router, RouterLink, RouterLinkActive } from "@angular/router";
import { filter, map, Observable, startWith, Subject, takeUntil, tap } from "rxjs";
//@ts-ignore
import Application from "@carbon/icons/es/application/32.js";
//@ts-ignore
import SidePanelClose from "@carbon/icons/es/side-panel--close/32.js";
//@ts-ignore
import SidePanelOpen from "@carbon/icons/es/side-panel--open/32.js";
//@ts-ignore
import Dashboard from "@carbon/icons/es/dashboard/32.js";
//@ts-ignore
import Code from "@carbon/icons/es/code/32.js";
import { ButtonType, CarbonIconComponent, ProfileDropdownComponent } from "design-system";
import { HeaderNavComponent } from "../header-nav/header-nav.component";
import { SignaloidWrapperService } from "@shared/services/api-services/signaloid-wrapper.service";
import { ProfileDropDownMenuItems } from "../header-nav/header.constants";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { EmbeddedDirective } from "../../../../shared/directives/embedded.directive";
import { EmbeddedService } from "../../../../shared/services/embedded/embedded.service";

@Component({
	selector: "app-side-nav",
	imports: [
		RouterLink,
		RouterLinkActive,
		NgForOf,
		NgIf,
		NgClass,
		CarbonIconComponent,
		NgOptimizedImage,
		HeaderNavComponent,
		ProfileDropdownComponent,
		MatProgressSpinner,
		AsyncPipe,
		EmbeddedDirective,
	],
	templateUrl: "./side-nav.component.html",
	styleUrl: "./side-nav.component.css",
})
export class SideNavComponent implements OnInit, OnDestroy {
	protected userDetails$: Observable<any> | undefined;
	protected tier$: Observable<string | undefined> | undefined;
	constructor(
		private router: Router,
		private cd: ChangeDetectorRef,
		private signaloidWrapperService: SignaloidWrapperService,
		private embeddedService: EmbeddedService,
	) {
    this.embeddedService.getIsEmbedded().pipe(takeUntil(this.onDestroy$)).subscribe((isEmbedded) => {
      if (!isEmbedded) {
        this.userDetails$ = this.signaloidWrapperService.getCurrentUserDetails();
        this.tier$ = this.signaloidWrapperService.getUserTier().pipe(
          tap((res) => console.log(res)),
          //@ts-ignore
          map((res) => res["subscription"]["Tier"]),
        );
      }
    });
  }
	isExpanded = true;
	selectedRoute = "";
	private onDestroy$ = new Subject();
	menuItems = [
		{
			icon: Dashboard,
			label: "Dashboard",
			route: "/dashboard",
		},
		{ icon: Application, label: "API App Highlights", route: "/demo" },
		{ icon: Code, label: "Code Playground", route: "/code-playground" },
	];

	toggleSidebar() {
		this.isExpanded = !this.isExpanded;
		this.cd.detectChanges();
	}

	ngOnInit() {
		this.router.events.pipe(takeUntil(this.onDestroy$)).subscribe((route) => {
			if (route.type === EventType.NavigationEnd) {
				this.selectedRoute = route.url;
			}
		});
	}
	ngOnDestroy() {
		this.onDestroy$.next(true);
		this.onDestroy$.complete();
	}
	protected readonly profileDropdownItems = ProfileDropDownMenuItems;
	protected readonly SidePanelClose = SidePanelClose;
	protected readonly ButtonType = ButtonType;
	protected readonly SidePanelOpen = SidePanelOpen;
}
